import React, { useState, useEffect } from 'react';
import About1 from '../../../assets/images/about-1.jpg';
import { Link } from 'react-router-dom';
import { axiosInstance, config } from '../config';
import Bredcrum from '../../common/Bredcrum';
import secureLocalStorage from 'react-secure-storage';
import moment from 'moment';
import team3 from '../../../assets/images/team/team-1.jpg';

const InstructorDetails = () => {
  const instructorData = secureLocalStorage.getItem('Instructor_Details');
  const [instructorDetail, setInstructorDetail] = useState(null);

  useEffect(() => {
    if (instructorData?.id) {
      axiosInstance
        .get(`getinstructor/${instructorData.id}`)
        .then((res) => {
          if (res.data.status === 'success') {
            setInstructorDetail(res.data.instructor);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [instructorData?.id]);

  const timeSlots = (instructorDetail?.time_slots || []).map((ts) => ({
    ...ts,
    parsedSlots: (() => {
      try {
        return JSON.parse(ts.slots);
      } catch {
        return [];
      }
    })(),
  }));

  return (
    <>
      <Bredcrum
        heading={'Instructor Profile'}
        path={[{ name: 'Instructor Profile', path: 'instructor' }]}
      />

      <section className="about-section">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="d-flex align-items-start justify-content-between mb-3">
                <h2>{instructorData?.name}</h2>
                <figure
                  className="image mb-0"
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={
                      instructorData?.image ? instructorData?.imageUrl : team3
                    }
                    alt=""
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </figure>
              </div>
              <div className="row clearfix">
                <div className="col-lg-5 col-md-6 col-sm-12 image-column">
                  <div className="image-box d-md-block d-none">
                    <figure className="image" style={{ width: '80%' }}>
                      <img
                        src={About1}
                        alt=""
                        style={{ width: '100%', height: '380px' }}
                      />
                    </figure>
                  </div>
                </div>
                <div className="col-lg-7 col-md-6 col-sm-12 content-column">
                  <div className="content-box">
                    <h5 className="fw-semibold mb-3">Instructor</h5>
                    <div className="text">
                      <p>{instructorData?.description}</p>
                    </div>
                  </div>
                </div>
              </div>
              {timeSlots.some((ts) => ts.parsedSlots.length > 0) && (
                <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                  <div
                    className="mt-4 custom-scroll"
                    style={{
                      border: '1px solid rgba(1,146,47,0.3)',
                      borderRadius: '8px',
                      maxHeight: '220px',
                      overflowY: 'auto',
                    }}
                  >
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      fontSize: '13px',
                      minWidth: '600px',
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background: '#01922f',
                          position: 'sticky',
                          top: 0,
                          zIndex: 1,
                        }}
                      >
                        <th
                          style={{
                            color: '#fff',
                            padding: '10px 16px',
                            fontWeight: 600,
                            textAlign: 'left',
                          }}
                        >
                          Day
                        </th>
                        <th
                          style={{
                            color: '#fff',
                            padding: '10px 16px',
                            fontWeight: 600,
                            textAlign: 'left',
                          }}
                        >
                          Location
                        </th>
                        <th
                          style={{
                            color: '#fff',
                            padding: '10px 16px',
                            fontWeight: 600,
                            textAlign: 'left',
                          }}
                        >
                          Lesson Type
                        </th>
                        <th
                          style={{
                            color: '#fff',
                            padding: '10px 16px',
                            fontWeight: 600,
                            textAlign: 'left',
                          }}
                        >
                          Time Slot
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {timeSlots.map((ts) =>
                        ts.parsedSlots.map((slot, i) => (
                          <tr
                            key={`${ts.id}-${i}`}
                            style={{
                              background:
                                i % 2 === 0 ? 'rgba(1,146,47,0.05)' : '#fff',
                              borderBottom: '1px solid rgba(1,146,47,0.15)',
                            }}
                          >
                            <td
                              style={{
                                padding: '10px 16px',
                                color: '#01922f',
                                fontWeight: 600,
                              }}
                            >
                              {ts.days}
                            </td>
                            <td
                              style={{ padding: '10px 16px', color: '#121113' }}
                            >
                              {slot.location || '—'}
                            </td>
                            <td
                              style={{ padding: '10px 16px', color: '#121113' }}
                            >
                              {slot.lesson_type || '—'}
                            </td>
                            <td
                              style={{
                                padding: '10px 16px',
                                color: '#121113',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {slot.start && slot.end
                                ? `${moment(slot.start, 'HH:mm').format('hh:mm A')} - ${moment(slot.end, 'HH:mm').format('hh:mm A')}`
                                : '—'}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                </div>
              )}
              <div className="btn-box mt-4 text-center">
                <Link
                  to={`${config.appUrl}book-a-lesson`}
                  state={{ data: instructorData?.id }}
                  className="theme-btn btn-two"
                >
                  Book Online Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InstructorDetails;
